<template>
    <!-- 注释掉的原始弹窗代码 -->
    <!-- <el-dialog :title="$t('ruleConfig.addDialogTitle')" :visible.sync="dialogVisible" width="70%"
        class="addConfigDialog" @close="dialogCloseHandle">
        123
    </el-dialog> -->

    <!-- 添加字段弹窗，宽度30%，追加到body -->
    <el-dialog width="30%" :title="$t('ruleConfig.addFieldTitle')" :visible.sync="dialogVisible" append-to-body
        @close="dialogCloseHandle">
        <!-- 表单主体，绑定formData -->
        <el-form :model="formData" ref="formRef" class="demo-ruleForm" style="width:80%;">
            <!-- 条件名称选择框，支持多选，折叠标签 -->
            <el-form-item label="条件名称">
                <el-select v-model="formData.selectIndex" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in getDataList" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
            </el-form-item>
        </el-form>
        <!-- 底部按钮区 -->
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '../../service';

export default {
    data() {
        return {
            // 弹窗显示状态
            dialogVisible: false,
            // 表单数据
            formData: {
                selectIndex: [], // 选中的条件索引
            },
            // 注释掉的下拉框数据
            // dataList: []
        }
    },
    computed: {
        // 注释掉的计算属性，用于过滤已选择的数据
        // getDataList() {
        //     // 返回tableList未选择过的的数据
        //     return this.dataList.filter(item => !this.tableList[item.prop])
        // }
    },
    props: {
        // 控制弹窗显示的prop
        addFieldDialogVisible: {
            type: Boolean,
            default: false
        },
        // 表格列表数据
        tableList: {
            type: Object,
        default: () => ({})
        },
        // 数据列表
        dataList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        // 获取数据列表，用于下拉框显示
        getDataList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    watch: {
        // 监听弹窗显示状态变化
        addFieldDialogVisible(val) {
            // 重置表单数据
            this.formData = {
            };
            this.dialogVisible = val;
        }
    },
    mounted() {
        // 组件挂载后的初始化逻辑（当前为空）
    },
    methods: {
        // 弹窗关闭处理，通知父组件
        dialogCloseHandle() {
            this.$emit('dialogCloseHandle');
        },
        // 提交表单处理
        submitForm() {
            // 遍历选中的索引
            for (let index of this.formData.selectIndex) {
                // 如果索引为undefined，关闭弹窗并返回
                if (index === undefined) {
                    this.dialogCloseHandle()
                    return
                }
                // 根据索引找到对应的数据
                // const data = this.dataList[index]
                const data = this.dataList.find(item => item.id === index)
                // 向父组件发送插入数据事件
                this.$emit('insertData', data)
            }
            // 关闭弹窗
            this.dialogCloseHandle()
        },
    },
}
</script>

<style lang="scss" scoped>
</style>